import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { paths } from "../../routes/paths";

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="assistant-admin-loader">
        <div className="assistant-admin-loader__badge">Assistant Admin</div>
        <div className="assistant-admin-loader__title">Đang kiểm tra quyền truy cập</div>
        <div className="assistant-admin-loader__sub">
          Hệ thống đang xác minh phiên đăng nhập trước khi mở dashboard.
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={paths.login}
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <Outlet />;
}
